import React from "react";
import { useTranslation } from "react-i18next";
import heroImg from "../../Images/Owision/testitudehero.png";

const TestitudeHeroSection = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="!mt-15 h-[60vh] md:h-[100vh] w-full flex flex-col md:flex-row gap-5 justify-center items-center text-white !px-10 md:!px-32">
        <div className="md:flex-1 text-center md:text-left">
          <h1 className="text-[26px] md:text-[60px] font-semibold">
            {t("testitude.herosection.title")}
          </h1>
          <h3 className="text-[14px] md:text-[30px] !my-3 md:!my-5">
            {t("testitude.herosection.subtitle")}
          </h3>
        </div>
        <div className="md:flex-1 justify-center items-center md:flex">
          <img src={heroImg} alt="Image" />
        </div>
      </div>
    </div>
  );
};

export default TestitudeHeroSection;
